import styled from 'styled-components';

import {
    Table,
} from '@zillow/constellation';

export const StyledTable = styled(Table)`
    display: block;
    overflow-x: auto;
`;
